export const Payments = {
  VISA_CARD: 0,
  MASTER_CARD: 1,
  AMEX: 2,
  GOOGLE_PLAY: 3,
  APPLE_PAY: 4,
}

export const paymentsData = [
  { label: 'Visa Card', value: 'visa' },
  { label: 'Master Card', value: 'master_card' },
  { label: 'Amex', value: 'amex' },
  { label: 'Google Pay', value: 'google_play' },
  { label: 'Apple Pay', value: 'apple_pay' },
]
